import type React from 'react';
import { Button, Col, Form, FormInstance, Row, Space } from 'antd';
import ButtonLink from 'components/theme_components/ButtonLink';
import type { FilterConfig, FilterValues } from 'types';
import FilterInput from './FiltreInputSFS';
import { SearchOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';

export interface FilterBarProps {
  form: FormInstance;
  subtitle?: string;
  filters: FilterConfig[];
  onSearch: (values: FilterValues) => void;
  onReset: () => void;
}

const Filter: React.FC<FilterBarProps> = ({
  form,
  subtitle,
  filters,
  onSearch,
  onReset,
}) => {
  const handleReset = () => {
    form.resetFields();
    onReset();
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    console.log('handleSearch', values);
    onSearch(values);
  };

  return (
    <Form form={form}>
      <Row>
        <Col span={20}>
          <Row gutter={5}>
            {filters.map((filter) => (
              <Col
                key={filter.key}
                md={{ flex: Math.floor((100 / filters.length))+ '%' }}

              >
                <FilterInput config={filter} />
              </Col>
            ))}
          </Row>
        </Col>

        <Col span={4}>
          <Row justify="end">
            <Col>
              <Button
                onClick={handleReset}
                className="btn-light no-border-radius ut-submit-btn mr-4 filter-btn-reset floatLeft"
              >
                <GetLabel label="reset" />
              </Button>

            </Col>

            <Col>
              <Button
                type="primary"
                onClick={handleSearch}
                className="ant-btn-primary no-border-radius ut-submit-btn filter-btn-search"
                icon={<SearchOutlined />}
              >
                <GetLabel label="search" />
              </Button>
            </Col>


          </Row>

        </Col>
      </Row>
    </Form>
  );
};

export default Filter;
